// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/home/jli/projects/xiaoju-sites/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-ghost-post-js": () => import("/home/jli/projects/xiaoju-sites/src/templates/ghost/post.js" /* webpackChunkName: "component---src-templates-ghost-post-js" */),
  "component---src-templates-ghost-index-js": () => import("/home/jli/projects/xiaoju-sites/src/templates/ghost/index.js" /* webpackChunkName: "component---src-templates-ghost-index-js" */),
  "component---src-templates-ghost-tag-js": () => import("/home/jli/projects/xiaoju-sites/src/templates/ghost/tag.js" /* webpackChunkName: "component---src-templates-ghost-tag-js" */),
  "component---src-pages-404-js": () => import("/home/jli/projects/xiaoju-sites/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/home/jli/projects/xiaoju-sites/.cache/data.json")

